module.exports = __webpack_public_path__ + "static/media/expPurple.47787f69.svg";